<template>
  <div
    class="w-full h-15 flex items-center text-white justify-between relative"
  >
    <div class="flex mx-8 items-center">
      <MainMenu @export="handleExport" />
      <WatchfaceType class="ml-6" />
    </div>

    <!-- center menus -->
    <div
      class="absolute left-1/2 -translate-x-1/2 flex justify-center items-center gap-5"
    >
      <div class="ml-5">
        <AddMenu />
      </div>
      <div class="border-l-[1px] border-l-[#ffffff]/30 border-solid h-6 ml-5" />
      <!-- 中间表达式菜单 -->
      <WidgetMenus />
      <div class="border-l-[1px] border-l-[#ffffff]/30 border-solid h-6 ml-5" />
      <div class="ml-5">
        <TempletMenu />
      </div>
    </div>
    <!-- right actions -->
    <div class="flex-shrink-0 flex mr-7">
      <SkuSelect class="mr-3" />
      <div
        class="flex items-center justify-center flex-col"
        :class="{
          '!cursor-not-allowed': watchfaceImageLoading || watchfaceOpening
        }"
        @click="handleExport"
      >
        <div class="w-[30px] h-[30px] flex items-center justify-center">
          <icon :icon="'export.svg'" :width="20" :height="20" fill="none" />
        </div>
        <div class="opacity-70 text-xs ml-0.5 -mb-[2px] mt-1">
          {{ watchfaceExporting ? '导出中...' : '导出' }}
        </div>
      </div>
    </div>

    <modal-watchface-export ref="exportModal" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import {
  watchfaceExporting,
  watchfaceImageLoading,
  watchfaceOpening
} from '@/hooks';

const watchfaceStore = useWatchfaceStore();

// 导出表盘
const exportModal = ref();
const handleExport = () => {
  if (watchfaceImageLoading.value || watchfaceOpening.value) return;
  exportModal.value?.open?.(watchfaceStore.path);
};
</script>

<style scoped lang="less"></style>
